<template>
    <div class="vip-page">
        <div class="vip-title">开通会员 <span class="sp1">免费畅玩</span>{{ landpageGameName }}</div>
        <div class="line"></div>
        <div class="tip">享全场上百款STEAM热游免费玩</div>
        <div class="vip-goods-wrap">
            <div @click="openPayDialog(item, index)" class="item" :class="[`vip${index + 1}`]" v-for="(item, index) in vipGoodsList" :key="item.id">
                <div class="icon" v-if="index === 0"></div>
                <div class="inner">
                    <div class="dv1">
                        {{ item.name }}
                    </div>
                    <div class="dv2">
                        <!-- 优先按照"原价展示渠道"逻辑展示价格 -->
                        <template v-if="item.showOriginPrice">
                            <span class="sp1">
                                <i class="i0">仅售</i>
                                <i class="i1">¥</i>
                                <i class="i2">{{ item.original_price }}</i>
                            </span>
                        </template>
                        <template v-else>
                            <span class="sp1">
                                <i class="i0">仅售</i>
                                <i class="i1">¥</i>
                                <i class="i2">{{ item.current_price }}</i>
                            </span>
                            <span class="sp2" v-if="item.original_price * 100 !== item.current_price * 100 && item.original_price * 100 > item.current_price * 100">
                                <i>原价</i>
                                <i>{{ item.original_price }}</i>
                            </span>
                        </template>
                    </div>
                    <div class="dv3">
                        <div class="btn">立即开通</div>
                    </div>
                    <div class="dv4">
                        <template v-if="index === 0"> 全场游戏免费畅玩尊享{{ item.name }} </template>
                        <template v-else-if="index === 1"> 全场游戏免费畅玩尊享{{ item.name }} </template>
                        <template v-else-if="index === 2"> 全场游戏免费畅玩尊享{{ item.name }} </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="intro-section" :class="[`bg${activeId}`]">
            <div class="tab">
                <span @mouseenter="handlerMouseEnter(item)" :class="[`sp${index + 1}`, activeId == item.id ? 'active' : '']" v-for="(item, index) in types" :key="item.id"></span>
            </div>
        </div>
        <div class="other-info">
            <div class="other-title"></div>
            <div class="qa-table">
                <div class="tabel-head">
                    <div class="row">
                        <div class="td1">服务说明</div>
                        <div class="td2">开通VIP会员</div>
                        <div class="td3">商品购买</div>
                    </div>
                </div>
                <div class="tabel-body">
                    <div class="row" v-for="item in list" :key="item.id">
                        <div class="td1">{{ item.td1 }}</div>
                        <div class="td2">{{ item.td2 }}</div>
                        <div class="td3">{{ item.td3 }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getVipShopList } from '@/http/api/vip'
import { getCookieToken, canPlayGame } from '@/utils/auth'
import { mapState } from 'vuex'

export default {
    name: 'VipPage',
    data() {
        return {
            activeId: 1,
            types: [{ id: 1 }, { id: 2 }, { id: 3 }],
            list: [
                { id: 1, td1: '商品说明', td2: '会员期内，拥有平台上所有游戏的游玩权', td3: '当前购买的商品可用于steam平台游戏' },
                { id: 2, td1: '购买后如何使用', td2: '使用乐速盒子一键上号，不支持账密提取，可能需要下载游戏客户端', td3: '购买后获得游戏账号&密码，可登录个人账号使用' },
                { id: 3, td1: '账号使用上的区别', td2: '随机分配（不保证每次启动游戏都是同一账号），与该游戏 的其他会员&用户共用账号，会因为同时在线人数多而排队', td3: '专属账号，随时可用' },
                { id: 4, td1: '游戏体验', td2: '多人共享，建议不要在游戏内进行任何消费行为不支持 steam商店、社区、个人账号信息编辑', td3: '支持游戏账号内的任意消费，steam功能 均正常使用、存档无忧' }
            ],
            is_first: '', // 0-->不是首次充值，1--》首次充值
            vipGoodsList: [],
            vipGoodsQuery: {
                page: 1,
                size: 3
            },
            channel: 'baidutg' // 和获取会员商品有关系，直接写死
        }
    },
    computed: {
        ...mapState(['landpageGameName']),
        wx() {
            return this.$store.state.payConfig.wx
        },
        zfb() {
            return this.$store.state.payConfig.zfb
        }
    },
    mounted() {
        this.getVipGoodsData()
        $('body').addClass('vip-bg')
        if (getCookieToken()) {
            this.$store.dispatch('userVipInfoAction')
        }
        this.$EventBus.$on('create-order', () => {
            this.openPayDialog(this.tempItem, this.tempIndex)
        })
    },
    beforeDestroy() {
        $('body').removeClass('vip-bg')
        clearInterval(this.getAuthTimeId)
        this.$EventBus.$off('create-order')
    },
    methods: {
        handlerMouseEnter(item) {
            this.activeId = item.id
        },
        // 获取vip商品列表--读取会员商品时，固定传入渠道
        getVipGoodsData() {
            getVipShopList({ ...this.vipGoodsQuery, channel: 'baidutg' }).then((res) => {
                if (res.code == 200 && this.$Utils.isObject(res.data)) {
                    const { is_first, list } = res.data
                    this.is_first = is_first
                    this.vipGoodsList = list.map((v) => {
                        v.showOriginPrice = false
                        try {
                            let formatChannel = JSON.parse(v.channel)
                            if (this.$Utils.isObject(formatChannel)) {
                                let priceChannel = formatChannel.price_channel
                                if (Array.isArray(priceChannel) && priceChannel.indexOf(this.channel) > -1) {
                                    v.showOriginPrice = true
                                }
                            }
                        } catch (error) {}
                        return v
                    })
                }
            })
        },
        async openPayDialog(item, index) {
            if (index == 2) {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 5, n4: item.id })
            } else if (index == 1) {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 6, n4: item.id })
            } else if (index == 0) {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 7, n4: item.id })
            }

            // 是否登录
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.openPayDialog(item, index)
                    }
                })
            }

            // 等待获取实名信息
            await this.$Utils.waitForAuthInfo()
            // 是否实名认证过
            if (!canPlayGame(this, 'create-order')) {
                this.tempItem = item
                this.tempIndex = index
                return false
            }

            this.$PayGoods.show({
                wx: this.wx,
                zfb: this.zfb,
                item,
                list: this.vipGoodsList
            })
        }
    }
}
</script>
<style lang="less" scoped>
.vip-page {
    margin: 0 auto;
    padding-top: 140px;
    width: @main-width;
    color: @color-txt-high;

    .vip-title {
        text-align: center;
        font-size: 36px;
        font-weight: bold;
        line-height: 40px;

        .sp1 {
            color: #00eb57;
        }
    }

    .line {
        margin: 5px auto 0;
        width: 143px;
        height: 23px;
        background: url(../../assets/line.png) center/100%;
    }

    .tip {
        margin: 9px auto 70px;
        text-align: center;
        font-size: 20px;
        line-height: 20px;
    }

    .vip-goods-wrap {
        margin-bottom: 80px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        height: 255px;

        .item {
            width: 370px;
            border-radius: 12px;
            position: relative;
            height: 192px;
            transition: 0.3s;

            .inner {
                overflow: hidden;
            }

            &.active,
            &:hover {
                height: 240px;

                .inner {
                    .dv3 {
                        height: 46px;
                        opacity: 1;
                    }
                }
            }

            .icon {
                position: absolute;
                top: -22px;
                right: -35px;
                width: 144px;
                height: 104px;
                background: url(../../assets/diamond-icon.png) center/100% no-repeat;
            }

            .dv1 {
                padding-top: 48px;
                text-align: center;
                line-height: 36px;
                font-size: 24px;
                font-weight: 700;
            }

            .dv2 {
                text-align: center;

                .sp1 {
                    margin-right: 4px;

                    .i0 {
                        position: relative;
                        font-size: 14px;
                        line-height: 21px;
                        margin: 0 4px;
                        top: -1px;
                    }

                    .i1 {
                        font-size: 16px;
                        font-weight: 700;
                        line-height: 24px;
                        margin-right: 2px;
                    }

                    .i2 {
                        font-size: 48px;
                        font-style: normal;
                        font-weight: bolder;
                    }
                }

                .sp2 {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                    text-decoration: line-through;
                }
            }

            .dv3 {
                margin: 2px auto 0;
                height: 0;
                opacity: 0;
                transition: 0.3s;
                overflow: hidden;

                .btn {
                    margin: 0 auto;
                    width: 288px;
                    height: 46px;
                    text-align: center;
                    line-height: 46px;
                    border-radius: 23px;
                    font-size: 16px;
                    font-weight: 700;
                    cursor: pointer;
                }
            }

            .dv4 {
                position: absolute;
                width: 214px;
                height: 20px;
                left: 50%;
                transform: translateX(-50%);
                bottom: 16px;
                border-radius: 4px;
                font-size: 12px;
                text-align: center;
                line-height: 20px;
            }

            &.vip1 {
                background: url(../../assets/vip1.png) left top no-repeat;

                .dv1 {
                    background: linear-gradient(90deg, #a45d1b 4.91%, #835d39 99.84%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .dv2 {
                    .sp1 {
                        color: #a45d1b;
                    }

                    .sp2 {
                        color: rgba(164, 93, 27, 0.5);
                    }
                }

                .dv3 {
                    .btn {
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        background: linear-gradient(180deg, #d7933e 0%, #9b5315 100%), linear-gradient(90deg, #d7d6f6 0%, #807ea9 100%);
                        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
                        color: rgb(253, 238, 220);
                    }
                }

                .dv4 {
                    color: rgba(164, 93, 27, 0.8);
                    border: 1px solid #e6ad5c;
                }
            }

            &.vip2 {
                background: url(../../assets/vip2.png) left top no-repeat;

                .dv1 {
                    background: linear-gradient(90deg, #ffe4ca 2.34%, #fffefd 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .dv2 {
                    .sp1 {
                        color: #ffe5cd;
                    }

                    .sp2 {
                        color: #ffe4ca;
                    }
                }

                .dv3 {
                    .btn {
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        background: linear-gradient(180deg, #e1c9b1 0%, #bb948b 100%), linear-gradient(90deg, #d7d6f6 0%, #807ea9 100%);
                        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
                        color: #ffffff;
                    }
                }

                .dv4 {
                    color: #8a95b2;
                    border: 1px solid #808aa2;
                }
            }

            &.vip3 {
                background: url(../../assets/vip3.png) left top no-repeat;

                .dv1 {
                    color: rgb(119, 95, 201);
                }

                .dv2 {
                    .sp1 {
                        color: #775fc9;
                    }

                    .sp2 {
                        color: rgba(119, 95, 201, 0.5);
                    }
                }

                .dv3 {
                    .btn {
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        background: linear-gradient(180deg, #9683ed 0%, #624ee1 100%);
                        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
                        color: #ede5f0;
                    }
                }

                .dv4 {
                    color: rgba(119, 95, 201, 0.8);
                    border: 1px solid #afa6e9;
                }
            }
        }
    }

    .intro-section {
        height: 851px;
        padding-top: 20px;

        &.bg1 {
            background: url(/static/imgs/bg1.png);
        }

        &.bg2 {
            background: url(/static/imgs/bg2.png);
        }

        &.bg3 {
            background: url(/static/imgs/bg3.png);
        }

        .tab {
            display: flex;
            height: 70px;

            span {
                flex: 1;

                &.sp1 {
                    background: url(../../assets/1.png) center 11px no-repeat;

                    &.active {
                        background-image: url(../../assets/1-active.png);
                        background-position-y: 7px;
                    }
                }

                &.sp2 {
                    background: url(../../assets/2.png) center 24px no-repeat;

                    &.active {
                        background-image: url(../../assets/2-active.png);
                        background-position-y: 7px;
                    }
                }

                &.sp3 {
                    background: url(../../assets/3.png) center 24px no-repeat;

                    &.active {
                        background-image: url(../../assets/3-active.png);
                        background-position-y: 7px;
                    }
                }
            }
        }
    }

    .other-info {
        padding-top: 35px;
        margin-top: 60px;
        margin-bottom: 60px;
        height: 483px;
        background-color: #272d2c;
        border-radius: 10px;

        .other-title {
            margin: 0 auto 9px;
            width: 426px;
            height: 65px;
            background: url(../../assets/vip-qa-title.png) center/100% no-repeat;
        }

        .qa-table {
            margin: 0 auto;
            width: 1080px;

            .tabel-head {
                border-radius: 10px 10px 0 0;
                background: @bg-color-17;
                height: 50px;
                color: @bg-color-cc;
                font-size: 16px;
            }

            .tabel-body {
                color: @color-txt-normal;

                .row {
                    height: 70px;
                    background: @bg-color-1E;

                    &:hover {
                        background: @bg-color-2e;
                    }

                    &:last-child {
                        border-radius: 0 0 10px 10px;
                    }
                }
            }

            .row {
                display: flex;
                height: 100%;

                .td1 {
                    width: 220px;
                }

                .td2,
                .td3 {
                    flex: 1;
                }

                .td1,
                .td2,
                .td3 {
                    .flex-center();
                    flex-shrink: 0;
                    text-align: center;
                }
            }
        }
    }
}
</style>
